import React, { memo, useRef } from 'react';

import { IconButton } from '../helpers/IconButton';
import Button from '../helpers/Button';

const NAME_ATTACHMENT = 'attachment';

const AttachmentRendererComponent = ({ target, onSelect, onDelete }) => {
  const inputFileSelectRef = useRef(null);

  const handleOpenFileModal = () => {
    if (inputFileSelectRef?.current) {
      inputFileSelectRef.current.value = '';
      inputFileSelectRef.current.click();
    }
  };

  const handleFileSelect = event => {
    if (event.currentTarget.files) {
      const { files } = event.currentTarget;

      onSelect(files[0]);
    }
  };

  const handleDeleteFile = fileName => {
    onDelete(target.id, fileName);
  };

  const attachedFiles = target.attachment?.map(file => (
    <div key={file} className="truncate-text d-flex align-items-center">
      <div className="truncate-text w-auto">{file}</div>
      <IconButton
        icon="remove"
        onClick={() => handleDeleteFile(file)}
        size="sm"
        title="Delete attachment"
        variant="danger"
      />
    </div>
  ));

  return (
    <>
      {attachedFiles}
      <Button onClick={handleOpenFileModal}>Browse</Button>
      <input
        ref={inputFileSelectRef}
        id={NAME_ATTACHMENT}
        name={NAME_ATTACHMENT}
        onChange={handleFileSelect}
        type="file"
        hidden
      />
    </>
  );
};

export const AttachmentRenderer = memo(AttachmentRendererComponent);
